'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _glamor = require('glamor');

var _redial = require('redial');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Table = require('@quixeltools/quixel-ui-library/dist/components/common/website/Table');

var _Table2 = _interopRequireDefault(_Table);

var _Button = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/Button');

var _Button2 = _interopRequireDefault(_Button);

var _activity = require('../../redux/modules/activity');

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _polyfluid = require('@quixeltools/quixel-ui-library/dist/utils/polyfluid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableSection = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  marginTop: {
    smallMedium: 2.578,
    large: [2.578, 3.4375]
  }
}));

var title = (0, _glamor.css)({
  color: _css.colors.white,
  fontWeight: 300
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  },
  marginBottom: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  }
}));

var table = (0, _glamor.css)({
  '& th': { width: '25%' },
  '& tbody': {
    color: _css.colors.white,
    fontSize: {
      smallMedium: 1,
      large: [1, 1.125]
    }
  }
});

var loadMore = (0, _glamor.css)({
  display: 'block'
}, (0, _polyfluid.polyfluid)({
  marginTop: {
    smallMedium: 2.25,
    large: [2.25, 3]
  }
}));

var UserActivity = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loadingActivity: state.activity.loadingActivity,
    currentPage: state.activity.currentPage,
    pages: state.activity.pages
  };
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(UserActivity, _React$Component);

  function UserActivity(props) {
    (0, _classCallCheck3.default)(this, UserActivity);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserActivity.__proto__ || (0, _getPrototypeOf2.default)(UserActivity)).call(this, props));

    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UserActivity, [{
    key: 'loadMore',
    value: function loadMore() {
      var _props = this.props,
          currentPage = _props.currentPage,
          pages = _props.pages,
          dispatch = _props.dispatch;

      if (currentPage < pages) {
        var nextPage = currentPage + 1;
        dispatch((0, _activity.loadUserActivityData)(nextPage, true));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          activity = _props2.activity,
          currentPage = _props2.currentPage,
          pages = _props2.pages,
          loadingActivity = _props2.loadingActivity;

      var isLastPage = currentPage === pages;

      var activityAction = _ramda2.default.cond([[_ramda2.default.equals('ASSET_DOWNLOADED'), _ramda2.default.always('Downloaded')], [_ramda2.default.equals('ASSET_ACQUIRED'), _ramda2.default.always('Acquired')], [_ramda2.default.equals('ASSET_ACQUIRED_DOWNLOAD'), _ramda2.default.always('Acquired & Downloaded')], [_ramda2.default.equals('PACK_ACQUIRED'), _ramda2.default.always('Pack purchased')]]);

      var activityTime = function activityTime(time) {
        return (0, _moment2.default)(time).fromNow();
      };

      var entries = activity && activity.length > 0 ? _ramda2.default.compose(_ramda2.default.map(function (item) {
        return [activityAction(item.action), activityTime(item.time), item.asset ? _react2.default.createElement(
          _reactRouter.Link,
          {
            className: (0, _glamor.css)({ color: _css.colors.white }),
            to: {
              pathname: '/assets/' + item.asset,
              state: {
                modal: true
              }
            } },
          item.asset
        ) : item.pack];
      }))(activity) : [];

      return _react2.default.createElement(
        'section',
        { className: tableSection },
        _react2.default.createElement(
          'h1',
          { className: title },
          'Activity'
        ),
        entries.length > 0 ? _react2.default.createElement(_Table2.default, {
          className: table,
          columnTitles: ['Action', 'Download Date', 'ID'],
          entries: entries
        }) : _react2.default.createElement(
          'div',
          null,
          'No activities found'
        ),
        !isLastPage && entries.length > 0 && _react2.default.createElement(_Button2.default, {
          className: loadMore,
          label: 'Load More',
          mode: 'primary',
          loading: loadingActivity,
          onClick: this.loadMore })
      );
    }
  }]);
  return UserActivity;
}(_react2.default.Component)) || _class);
exports.default = UserActivity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserActivity/UserActivity.jsx
// module id = 2668
// module chunks = 0